// This model should contain ONLY parameters that a user can change in a listing and not system set attributes
// Warn: If system set attributes are defined here, they will overwrite the system values with undefined or '' values
export const listingModel = {
  location: {
    address: {
      country: "",
      street: "",
      apartNumber: "",
      municipality: "",
      county: "",
      number:"",
      formattedAD:"",
      neighbourhood:""
    },
    geoCoords : [{lat: 59.436962, lng:24.753574}],
    lestCoords: [],
    geoBoundingBox: {},
    ehrBuildCode: "",
    inAdsOid: "",
    ehak:""
  },
  googLocation:{
    aal1: '',
    locality:''
  },
  availDet: {
    status: 'draft',
    visibility: 'all',
    statusDesc: "",
    isBooked: 'false',
    bookedUntil: "",
    rentedOut: 'false',
    rentedBetween:{
      from:"",
      to:""
    }
  },
  genDet: {
    info: {
      rus: "",
      eng: "",
      est: "",
    },
    slogan: {
      rus: "",
      eng: "",
      est: "",
    },
    propType: {
      superType: "",
      subType: ""
    },
    pictureUrls: [],
    thumbUrls: []
  },
  techDet: {
    storage: [],
    buildingYear: "",
    buildingMat: "",
    buildingRoofType: "",
    internalWalls: [],
    buildingEnLable: "",
    parking: {
      payment: "",
      placement: ""
    },
    areaSizeUnit: "",
    generalArea: "",
    livingArea: "",
    heatedArea: "",
    totalArea: "",
    entryFloor: "",
    buildingNrOfFloor: "",
    condition: "",
    readiness: "",
    nrOfRooms: "",
    nrOfGuests: "",
    nrOfBedrooms: "",
    nrOfBathrooms: "",
    nrOfLivingRooms: "",
    nrOfKit: "",
    nrOfOpenKit: "",
    nrOfBalconies: "",
    sanOptions: [],
    water: "",
    wcAndBathSeparated: "",
    attic: "",
    shower: "",
    stoves: [],
    heatings: [],
    amenities: [],
    balcony: [],
    suitable:[]
  },
  txnDet : {
    txnType : "",
    m2Price : undefined,
    depositMonthly : undefined,
    depositDaily : undefined,
    priceDaily:undefined,
    priceMonthly:undefined,
    weeklyDiscount:undefined,
    mediumPeriodDiscount:undefined,
    cleaningFees:undefined,
    essentialsFees:undefined,
    longPeriodDiscount:undefined,
    currency : "eur",
    ADDFees : [],
    ADDUtiltyFees : [],
    priceIncludes : [],
    limitation : "",
    propOwnership : ""
  },
  marketingDet: {
    images: [],
    inPaidPortals: false,
    tagwords:"",
    shortDesc: ""
  },
  creationDet: {
    createdBy: "",
    createdDate: "",
    lstModDate: "",
    lstModBy: ""
  },
  owner:{
    uid: ""
  },
  maaklerID:undefined,
  fees: {},
}



// WEBPACK FOOTER //
// ./src/dataModel.js